export const APP_PATH = process.env.APP_PATH || '/book-an-appointment';
export const LOCAL_VETSPIRE_URL = `${APP_PATH}/api/vetspire/`;

export enum TagTheme {
	Lovet = 'lovet',
}

export const SCHEDULING_URL_ATTRIBUTE_NAME = 'Scheduling URL';

export const VETSPIRE_SCHEDULING_KEYWORD = 'book-an-appointment';

// not all-encompassing, just the keys used specifically by this app
export enum CustomAttributeKeys {
	schedulingURL = 'Scheduling URL',
	scheduleType = 'Schedule Type',
	hospitalName = 'Hospital Name',
	midWeekPromotion = 'Mid Week Promotion',
	teletriageEnabled = 'Teletriage Enabled',
	intelligentSchedulingEnabled = 'Intelligent Scheduling Enabled',
}

export const CACHE_CONTROL_NO_CACHE = 'no-cache, no-store, must-revalidate';

export const SENTRY_DSN =
	'https://1e0cce92d37b9d8ef026edbf57057be0@o4508615315554304.ingest.us.sentry.io/4509408662585345';

export const DEFAULT_EXPIRY_TIME = 30 * 60 * 1000; // 30 minutes

export const EXPERIAN_SEARCH_API = 'https://api.experianaperture.io/address/search/v1';
export const EXPERIAN_VALIDATE_API = 'https://api.experianaperture.io/address/validate/v1';
export const EXPERIAN_FORMAT_API = 'https://api.experianaperture.io/address/format/v1';

// Image CDN Hosts for image optimization
export const contentfulCDNHost = 'images.ctfassets.net';
export const brandFolderCDNHost = 'cdn.bfldr.com';

export const MAX_CONTENT_SIZE = 1920;
export const imageResponsiveSizes: number[] = [200, 400, 640, 750, 828, 1080, 1200, 1920];
export const HEADER_HEIGHT = '4.8125rem'; // 77px

// Google Recaptcha
export const RECAPTCHA_ACTION_NAME = 'lovet_book_appointment_confirm';
export const RECAPTCHA_THRESHOLD = 0.5;

// 72 hours delay of lab results
export const LOVET_DELAY_FILTER_LAB_RESULTS_MINUTES = 2;
export const LOVET_NOOP_FILTER_LAB_RESULTS = false;
export const LOVET_PROD_DELAY_FILTER_LAB_RESULTS_MINUTES = 4320;
export const LOVET_PROD_NOOP_FILTER_LAB_RESULTS = false;

// Vetspire client tags that block online booking.
// Matched by name (not ID) because tag IDs differ between stage and prod.
export const COLLECTIONS_TAG_NAMES = [
	'Post-Collections [Balance Unpaid]',
	'Collections [Active]',
	'Collections - (Manual Tags)',
] as const;
